import "./src/styles/global.css";

// eslint-disable-next-line no-use-before-define
import React from "react";
import { GlobalProvider } from "./src/shared/GlobalContext";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const wrapRootElement = ({ element }) => (
  <GlobalProvider>{element}</GlobalProvider>
);
